// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"163":"map","251":"begeleider-setup","688":"student-setup","930":"setup"}[chunkId] + "." + {"163":"82b664e1","251":"934bfa66","688":"931ee3eb","930":"1c6a8737"}[chunkId] + ".css";
};